import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../panels/BasePanelPage";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {inlineUserDashboardState} from "../InlineUserDashboardState";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {apiDeletePaymentMethod, PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {PanelToast} from "../../../PanelToast";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";


@registerStyle(PaymentMethodStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardRemoveCardPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeCard,
        };
    }

    async removeCard() {
        LoadingSpinner.show();
        try {
            await apiDeletePaymentMethod(inlineUserDashboardState.card.id);
            Router.back();
            PanelToast.showSuccess(Messages.cardRemoved);
        } catch (error) {
            PanelToast.showError(error.message);
        } finally {
            LoadingSpinner.hide();
        }
    }

    render() {
        const {styleSheet} = this;
        const {card} = inlineUserDashboardState;

        return [
            <div>{Messages.removeCardEndingIn(card.getBrand(), card.getLastDigits())}</div>,
            <MerchantButton className={styleSheet.button} label={Messages.remove} onClick={() => this.removeCard()}/>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => Router.back()}>
                    {Messages.cancel}
                </div>
            </div>
        ];
    }
}
